import React, { Fragment, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import ReactJson from "react-json-view";
import { useState } from "react";
import API from "components/Leasing/api/api.main";
import { Auth } from "aws-amplify";
import { mapInterfaceCreate } from "../utils/mapData";

function InterfaceCreateModal({
  loan,
  openModalInterface,
  setOpenModalInterfaceCreate,
  env = "sandbox",
}) {
  const [interfaceCreates, setInterfaceCreates] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (openModalInterface && !interfaceCreates.length) {
      fetchInterfaceCreate();
    }
  }, [openModalInterface]);

  const fetchInterfaceCreate = async () => {
    try {
      setLoading(true);

      const pathUrl =
        env === "prod"
          ? "/leasing/interfaceCreate"
          : "/leasing/loanSandbox/interfaceCreate";

      const response = await API.get(
        "MoneyHubAdmin",
        `${pathUrl}/${loan.loan_id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      const interfaceCreate = mapInterfaceCreate(response.interfaceCreate);

      // console.log("interfaceCreate", interfaceCreate)

      // const total = interfaceCreate.sequences.reduce((prev, se) => {
      //   return prev + se.INTEREST_AMOUNT_2
      // }, 0);
      // console.log("total", total)
      setInterfaceCreates(interfaceCreate);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Transition appear show={openModalInterface} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={() => setOpenModalInterfaceCreate(false)}
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-50"
            leave="ease-in duration-200"
            leaveFrom="opacity-50"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-50" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="border border-gray-200 z-50 inline-block w-full max-w-xl p-6 my-8 overflow-visible text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <Dialog.Title
                as="h3"
                className="text-lg font-medium leading-6 text-gray-900 flex justify-between"
              >
                <div>Interface Create</div>
                {!interfaceCreates && !loading && <div>Not found</div>}
                {loading && <div>Loading...</div>}
                {/* {!loading && (
                  <div>
                    <input
                      // onChange={onChangeSearch}
                      placeholder="Search tag, key"
                      // value={searchBuro}
                      className="px-3  py-3 placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
                    />
                  </div>
                )} */}
              </Dialog.Title>
              {!loading && interfaceCreates && (
                <ReactJson
                  src={interfaceCreates}
                  name={false}
                  enableClipboard={false}
                  displayObjectSize={false}
                  displayDataTypes={false}
                />
              )}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}

export default InterfaceCreateModal;
